import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {CommonService} from '../../../../services/common.service';
import {ImagesService} from '../../../../services/images.service';
import {FavouritesService} from '../../../../services/favourites.service';
import environment from '../../../../../environment';

@Component({
  selector: 'product-list',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class ProductListComponent implements OnInit, OnChanges {
  @Input() items = [];
  private favouriteIds: Set<number | string> | null = null;

  constructor(
    public commonService: CommonService,
    private imageService: ImagesService,
    private favouritesService: FavouritesService
  ) {}

  async ngOnInit() {
    try {
      const favouriteObjects =
        await this.favouritesService.getUserListingFavourites();
      this.favouriteIds = new Set(favouriteObjects.map(fav => fav.id));
      this.syncFavouriteState();
    } catch (error) {
      if (environment.settings.verboseLogging) {
        console.error('Error loading favourites:', error);
      }
    }
  }

  ngOnChanges() {
    this.syncFavouriteState();
  }

  async toggleFavourite(item: any): Promise<void> {
    const newStatus = !item.favourited;
    try {
      item.favourited = newStatus;
      this.updateFavouriteIds(item.id, newStatus);
      await this.favouritesService.editUserListingFavourite(item.id, newStatus);
    } catch (error) {
      item.favourited = !newStatus;
      this.updateFavouriteIds(item.id, item.favourited);
      if (environment.settings.verboseLogging) {
        console.log('err', error.message);
      }
    }
  }

  private syncFavouriteState() {
    if (!this.favouriteIds || !Array.isArray(this.items)) {
      return;
    }

    this.items.forEach(item => {
      item.favourited = this.favouriteIds.has(item.id);
    });
  }

  private updateFavouriteIds(itemId: number | string, isFavourited: boolean) {
    if (!this.favouriteIds) {
      this.favouriteIds = new Set();
    }

    if (isFavourited) {
      this.favouriteIds.add(itemId);
      return;
    }

    this.favouriteIds.delete(itemId);
  }

  public navigate(path) {
    const url =
      path.state === 'listing'
        ? `/listing/${path.id}/${path.slug}`
        : `/company/${path.companySlug}`;
    this.commonService.navigate(url);
  }

  public getImageUrl(item) {
    if (item && item.s3_thumbnail_url) {
      return item.s3_thumbnail_url;
    }

    if (!item || !item.company_id || !item.image_id || !item.image_name) {
      return '';
    }
    return this.imageService.getCategoryImageUrl(
      item.company_id,
      item.image_id,
      item.image_name
    );
  }
}
